var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"root"}},[_c('div',{staticClass:"todo-container"},[_c('div',{staticClass:"todo-wrap"},[_c('TodoHeader',{on:{"addTodo":_vm.addTodo}}),_c('TodoList',{attrs:{"todos":_vm.todos}}),_c('TodoFooter',{attrs:{"todos":_vm.todos},on:{"checkAllTodo":_vm.checkAllTodo,"clearAllTodo":_vm.clearAllTodo}})],1)])])
}
var staticRenderFns = []

export { render, staticRenderFns }